import { render, staticRenderFns } from "./DefaultNav.vue?vue&type=template&id=98c4cbe4&scoped=true&"
import script from "./DefaultNav.vue?vue&type=script&lang=js&"
export * from "./DefaultNav.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNav.vue?vue&type=style&index=0&id=98c4cbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c4cbe4",
  null
  
)

export default component.exports